import React from "react";
export const CardImage=()=>{
    return(
        <>
        <div className="row">
            <div className="col-6"><img src={"asset/images/homeImage/IMG_0603.jpg"} className="img-fluid" alt=""/></div>
            <div className="col-6"><img src={"asset/images/homeImage/photo_2019-11-04_10-06-45.png"} className="img-fluid" alt="" style={{minWidth:"100%"}}/></div>
        </div>


        </>



    )


}